import React, { useEffect, useState } from 'react';

import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';
import StoreWhite from '../../../../img/store-white.svg';
import HighPriory from '../../../../img/priority_high.svg';
import VerifiedWhite from '../../../../img/verified-white.svg';
import { Invoice, Transacao } from '../../../../model/model';

import momentTZ from 'moment-timezone';

interface ModalProps {
	modalVisible: boolean;
	setModalVisible(b: boolean): void;
	transacao: Transacao;
}

export default function PagamentoDetalhes(props: ModalProps) {
	const { modalVisible, setModalVisible, transacao } = props;

	const [showScroll, setShowScroll] = useState(false);

	const [clienteVinculado, setClienteVinculado] = useState(true);
	const [clienteCheck, setClientCheck] = useState(false);

	const [uc, setUc] = useState('-');
	const [doc, setDoc] = useState('');


	const [faturasVinculadas, setFaturasVinculadas] = useState<Invoice[]>([]);

	const statuses = [
		'Processando',
		'Processado',
		'Cancelado',
		'Falha',
		'Chargeback',
		'Suspeito'		
	];

	function getStatusColor() {
		const data = [
			{ label: '', color: '', value: -1 },
			{ label: 'Processando', color: '#1588D1', value: 0 },
			{ label: 'Em andamento', color: '#7CB342', value: 1 },
			{ label: 'Cancelado', color: '#757575', value: 2 },
			{ label: 'Falha', color: '#E53935', value: 3 },
			{ label: 'Pendente', color: '#7CB342', value: 4 },
			{ label: 'Completo', color: '#7CB342', value: 5 },
			{ label: 'Em conflito', color: '#FFBB33', value: 7 },
			{ label: 'CHARGEBACK', color: '#5E35B1', value: 8 },
			{ label: 'Rejeitado', color: '#757575', value: 9 },
			{ label: 'Restrito', color: '#757575', value: 11 },
			{ label: 'Registrado', color: '#7CB342', value: 12 },
		];

		const f = data.find((d) => d.value === transacao?.status);
		if (f) {
			return f.color;
		}
		return '#676767';
	}

	const tipos = ['', 'Débito', 'Crédito'];

	function renderMoney(value: any) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	function handleScroll() {
		if (showScroll === false) {
			setShowScroll(true);

			setTimeout(() => {
				setShowScroll(false);
			}, 2000);
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll, true);
	}, []);

	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		setShowModal(modalVisible);
		if (!modalVisible) {
			setClienteVinculado(true);
			setClientCheck(false);

			setFaturasVinculadas([]);
		} else {
			setClienteVinculado(true);
		}
	}, [modalVisible]);

	useEffect(() => {
		setClienteVinculado(true);
		setUc(transacao.pagamento?.uc || '-');
		setDoc(transacao.doc || '-');
	}, [transacao]);

	function formatDoc() {
		let value = doc;
		value = value.replace(/\D/g, '');
		if (value.length <= 11) {
			value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
		} else {
			value = value.replace(
				/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
				'$1.$2.$3/$4-$5'
			);
		}
		return value;
	}

	function CalcularVinculadas() {
		let t = 0;
		if (faturasVinculadas.length > 0) {
			faturasVinculadas.forEach((fv) => {
				t = t + parseFloat(fv.C1_TOTAL_CORRIGIDO);
			});
		}

		return `${t}`;
	}

	function VinculadasValorRestante() {
		const cv = parseFloat(CalcularVinculadas());
		const tv = parseFloat(transacao.valor);
		const res = cv - tv;
		return res;
	}

	function FaturaVinculadaTooltipText() {
		if (faturasVinculadas.length > 0) {
			return `O valor total pago não corresponde à soma do valor total de faturas. ${VinculadasValorRestante() > 0 ? 'Excedem por' : 'Faltam'
				} `;
		} else return 'Nenhuma fatura vinculada';
	}

	return (
		<Modal
			fullscreen
			dialogClassName='hide-this-modal'
			centered={false}
			animation={false}
			show={modalVisible}
			onHide={() => {
				setModalVisible(false);
			}}>
			<Modal.Body>
				<div
					onClick={(e) => {
						e.preventDefault();
						setModalVisible(false);
					}}
					style={{
						position: 'fixed',
						height: '100vh',
						width: '100vw',
						top: 0,
						left: 0,
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
					<ModalMainContainer
						visible={showModal}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}>
						<ModalHeader>
							<HeaderTitle>{'Detalhes do pagamento'}</HeaderTitle>

							{transacao.pagamento && (
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<HeaderButton
										onClick={(e) => {
											e.preventDefault();
											setModalVisible(false);
										}}
										style={{ background: '#28A745', color: '#FFFFFF' }}>
										Fechar
									</HeaderButton>
								</div>
							)}
						</ModalHeader>
						<ModalContainer showScroll={showScroll}>
							<BodyMenu>
								{clienteVinculado ? (
									<MenuItem showChecked={clienteCheck}>
										<p className='menu_item_title menu_margin_b-8'>Cliente</p>

										<div className='menu_margin_b-16'>
											<p className='menu_item_label menu_margin_b-2'>nome</p>
											<p className='menu_item_info'>{transacao?.cliente}</p>
										</div>

										<div
											className={clienteCheck ? 'menu_margin_b-16' : ''}
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
											}}>
											<div style={{ marginRight: 25 }}>
												<p className='menu_item_label menu_margin_b-2'>UC</p>
												<p className='menu_item_info'>{uc}</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>
													documento
												</p>
												<p className='menu_item_info'>
													{formatDoc() !== '' ? formatDoc() : '-'}
												</p>
											</div>
										</div>

										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														Cliente vinculado
													</span>
												</Tooltip>
											}>
											<div className='menu_top_fixed_tr_checked'>
												<img alt='v' src={VerifiedWhite} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								) : (
									<MenuItem showWarning={true}>
										<p className='menu_item_title menu_margin_b-32'>
											Vincular cliente
										</p>

										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														nenhum cliente vinculado
													</span>
												</Tooltip>
											}>
											<div
												onClick={(e) => {
													e.preventDefault();
												}}
												className='menu_top_fixed_tr'>
												<img alt='!' src={HighPriory} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								)}
								<MenuItem>
									<div
										className='menu_margin_b-20'
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<p className='menu_item_title'>Pagamento </p>
										<div
											style={{
												background: getStatusColor(),
											}}
											className='menu_item_status'>
											{statuses[transacao?.status]}
										</div>
									</div>
									<div
										className='menu_margin_b-16'
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<p className='menu_item_label'>total pago</p>
										<p className='menu_item_heavy'>
											{renderMoney(transacao?.valor)}
										</p>
									</div>

									<div
										className='menu_margin_b-16'
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<p className='menu_item_label'>Criado em</p>
										<p className='menu_item_info'>
											{momentTZ
												.tz(transacao?.cadastro, 'America/Sao_Paulo')
												.format('DD/MM/YYYY HH:mm:ss')}
										</p>
									</div>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<p className='menu_item_label'>Processado em</p>
										<p className='menu_item_info'>
											{transacao?.processado ? momentTZ
												.tz(transacao?.processado, 'America/Sao_Paulo')
												.format('DD/MM/YYYY HH:mm:ss') : '-'}
										</p>
									</div>
								</MenuItem>

								<MenuItem>
									<p className='menu_item_title menu_margin_b-8'>
										Ponto de Venda
									</p>

									<div
										className='menu_margin_b-16'
										style={{
											flexDirection: 'row',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<div>
											<p className='menu_item_label menu_margin_b-2'>
												nome da loja
											</p>
											<p className='menu_item_info'>
												{transacao?.pontoVenda &&
													transacao?.pontoVenda.unidade &&
													transacao?.pontoVenda.unidade.nome
													? transacao.pontoVenda.unidade.nome
													: '-'}
											</p>
										</div>
										<div>
											<p className='menu_item_label menu_margin_b-2'>
												Identificador
											</p>
											<p className='menu_item_info'>
												{transacao?.pontoVenda
													? transacao?.pontoVenda.apelido.toUpperCase()
													: '-'}
											</p>
										</div>
									</div>
									<div>
										<p className='menu_item_label menu_margin_b-2'>Cidade</p>
										<p className='menu_item_info'>
											{transacao?.pontoVenda &&
												transacao?.pontoVenda.unidade &&
												transacao?.pontoVenda.unidade.cidade
												? transacao?.pontoVenda.unidade.cidade
												: '-'}
										</p>
									</div>

									<OverlayTrigger
										key={'1'}
										placement='left'
										overlay={
											<Tooltip id='menu_tool_tip'>
												<span style={{ textTransform: 'capitalize' }}>
													item local
												</span>
											</Tooltip>
										}>
										<div className='menu_bottom_fixed_br'>
											<img alt='store' src={StoreWhite} />
										</div>
									</OverlayTrigger>
								</MenuItem>

								<MenuItem style={{ display: 'none' }}>
									<p className='menu_item_title menu_margin_b-8'>Ajuri</p>

									<div
										style={{
											flexDirection: 'row',
											display: 'flex',
											alignItems: 'center',
										}}>
										<div style={{ marginRight: 25 }}>
											<p className='menu_item_label menu_margin_b-2'>
												Identificador
											</p>
											<p className='menu_item_info'>
												{`transacao?.identificador || '-'`}
											</p>
										</div>
										<div>
											<p className='menu_item_label menu_margin_b-8=2'>cupom</p>
											<p className='menu_item_info'>
												{`transacao?.cupom || '-'`}
											</p>
										</div>
									</div>
								</MenuItem>

								{<div style={{ background: 'transparent', padding: 10 }} />}
							</BodyMenu>
							<BodyMenu style={{ marginLeft: 16 }}>
								<MenuItem>
									<p className='menu_item_title menu_margin_b-8'>
										Detalhes da transação
									</p>

									<div className={''}>
										<div
											className='menu_margin_b-16'
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<div>
												<p className='menu_item_label menu_margin_b-2'>Tipo</p>
												<p className='menu_item_info'>
													{tipos[parseInt(transacao.tipo)]} (
													{transacao.parcelas ? transacao.parcelas : '1'}x)
												</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>
													Valor
												</p>
												<p className='menu_item_info'>
													{renderMoney(transacao.valor)}
												</p>
											</div>
										</div>
										<div
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<div>
												<p className='menu_item_label menu_margin_b-2'>Pan</p>
												<p className='menu_item_info'>{transacao.pan || '-'}</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>NSU</p>
												<p className='menu_item_info'>{transacao.atk || '-'}</p>
											</div>
										</div>
									</div>
								</MenuItem>

								<MenuItem>
									<p
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
										}}
										className='menu_item_title menu_margin_b-8'>
										Faturas Pagas{' '}
										<span
											style={{
												color: '#FFFFFF',
												marginLeft: 8,
												fontSize: 13,
											}}
											className='menu_circle'>
											{transacao.pagamento?.faturas.length || 0}
										</span>
									</p>
									<table>
										<thead>
											<tr className=''>
												<th className='menu_item_label menu_padding_b-16'>
													Fatura
												</th>
												<th className='menu_item_label menu_padding_b-16'>
													Vencimento
												</th>
												<th className='menu_item_label float_right menu_padding_b-16'>
													Valor
												</th>
											</tr>
										</thead>
										<tbody>
											{transacao.pagamento?.faturas &&
												transacao.pagamento?.faturas.map((fat) => {
													return (
														<tr className='' key={fat.id}>
															<td className='menu_item_info_bold menu_padding_b-16'>
																{fat.ref}
																{parseInt(fat.fd) > 0 ? ' - ' + fat.fd : ''}
															</td>
															<td className='menu_item_info_regular menu_padding_b-16'>
																{fat.vencimento}
															</td>
															<td className='menu_item_info_bold float_right menu_padding_b-16'>
																{renderMoney(fat.total)}
															</td>
														</tr>
													);
												})}
										</tbody>
									</table>

									<OverlayTrigger
										key={'1'}
										placement='left'
										overlay={
											<Tooltip id='menu_tool_tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{FaturaVinculadaTooltipText()}
													{VinculadasValorRestante() !== 0 && (
														<span style={{ fontWeight: 'bold' }}>
															{renderMoney(Math.abs(VinculadasValorRestante()))}
														</span>
													)}
												</span>
											</Tooltip>
										}>
										<div className='menu_top_fixed_tr'>
											<img alt='!' src={HighPriory} />
										</div>
									</OverlayTrigger>
								</MenuItem>
							</BodyMenu>
						</ModalContainer>
					</ModalMainContainer>
				</div>
			</Modal.Body>
		</Modal>
	);
}

interface MainContainerProps {
	visible?: boolean;
}

const ModalMainContainer = styled.div<MainContainerProps>`
	background: #ffffff 0% 0% no-repeat padding-box;
	box-shadow: -12px 12px 16px #00000029;
	width: 100vw;
	max-width: 730px;
	height: calc(100vh);
	transition: all 0.4s;

	opacity: ${(props) => (props.visible ? 1 : 0)};
`;

const ModalHeader = styled.div`
	background: #f6f6f6 0% 0% no-repeat padding-box;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding-top: 21px;
	padding-bottom: 21px;

	padding-left: 30px;
	padding-right: 30px;
	height: 80px;
`;

const HeaderTitle = styled.h1`
	font: normal normal 500 24px/32px Roboto;
	letter-spacing: 0px;
	color: #222222;
`;

const HeaderButton = styled.button`
	border-radius: 19px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 38px;
	padding-left: 16px;
	padding-right: 16px;

	text-align: center;
	font: normal normal 500 16px/21px Roboto;
	letter-spacing: 0px;
	border: 0;
`;

interface ModalContainerProps {
	showScroll?: boolean;
}

const ModalContainer = styled.div<ModalContainerProps>`
	background: #ffffff 0% 0% no-repeat padding-box;
	opacity: 1;
	display: flex;
	flex-direction: row;
	height: calc(100vh - 80px - 20px);
	padding: 30px;
	padding-top: 0;
	margin-top: 20px;
	overflow-y: scroll;

	::-webkit-scrollbar {
		background: transparent;
		width: 12px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${(props) =>
		props.showScroll ? 'rgba(103, 103, 103, 0.5)' : 'transparent'};
		border-radius: 20px;
		border: 2.5px solid rgba(0, 0, 0, 0);
		border-right: 5px solid rgba(0, 0, 0, 0);

		background-clip: padding-box;
		max-height: 5px;
		transition: all 1s;
	}
`;

const BodyMenu = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;

interface MenuItemProps {
	showWarning?: boolean;
	showChecked?: boolean;
}

const MenuItem = styled.div<MenuItemProps>`
	background: #f6f6f6 0% 0% no-repeat padding-box;
	border-radius: 24px;
	padding: 20px;
	margin-bottom: 15px;
	position: relative;

	input {
		outline: none;
	}

	.menu_input_container {
		background: #ffffff 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 3px 6px #00000029;
		border-radius: 19px;
		height: 38px;
		display: flex;
		flex-direction: row;
		padding-right: 0;
		align-items: center;
		padding-left: 12px;

		img {
			width: 20px;
			height: 20px;
		}

		input {
			flex: 1;
			margin: 0;
			background: transparent;
			height: 38px;
			border: 0;
		}

		.menu_search_button {
			background: #28a745 0% 0% no-repeat padding-box;
			border-radius: 19px;
			height: 38px;
			text-align: center;
			font: normal normal 500 13px/18px Roboto;
			letter-spacing: 0px;
			color: #ffffff;
			padding-left: 16px;
			padding-right: 16px;
			display: flex;
			align-items: center;
			border: 0;
		}
	}

	.float_right {
		float: right;
	}

	.table_row {
	}

	table {
		width: 100%;
		border-spacing: 16px;
	}

	.menu_gray_line {
		border-bottom: 1px solid #998f8f;
	}

	.menu_margin_b-8 {
		margin-bottom: 8px;
	}
	.menu_padding_b-8 {
		padding-bottom: 8px;
	}

	.menu_margin_b-24 {
		margin-bottom: 24px;
	}
	.menu_padding_b-24 {
		padding-bottom: 24px;
	}

	.menu_margin_b-16 {
		margin-bottom: 16px;
	}

	.menu_margin_b-32 {
		margin-bottom: 32px;
	}

	.menu_padding_b-16 {
		padding-bottom: 16px;
	}
	.menu_margin_b-2 {
		margin-bottom: 2px;
	}

	.menu_margin_b-20 {
		margin-bottom: 20px;
	}

	.menu_circle {
		display: flex;
		justify-content: center;
		align-items: center;
		background: #28a745 0% 0% no-repeat padding-box;
		border-radius: 12px;
		width: 24px;
		height: 24px;
	}

	p {
		margin: 0;
	}

	.menu_item_title {
		text-align: left;
		font: normal normal bold 16px/21px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}
	.menu_item_label {
		text-align: left;
		font: normal normal normal 11px/15px Roboto;
		letter-spacing: 0px;
		color: #676767;
		text-transform: uppercase;
	}

	.menu_item_info {
		text-align: left;
		font: normal normal 500 15px/20px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_item_info_bold {
		text-align: left;
		font: normal normal 700 13px/18px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.h-32px {
		height: 32px;
	}

	.menu_item_info_value_container {
		background: #ffffff 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 3px 6px #00000029;
		border-radius: 16px;
		padding: 4px;
		height: 32px;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;

		.text_container {
			flex: 1;
			text-align: right;
			padding-right: 8px;
		}

		.delete_button {
			width: 24px;
			height: 24px;
			color: #ffffff;
			background: #dc3545;
			border: 0;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.menu_item_info_regular {
		text-align: left;
		font: normal normal 400 13px/18px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_item_status {
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		font: normal normal 500 10px Roboto;
		letter-spacing: 0.5px;
		color: #ffffff;
		text-transform: uppercase;
		padding-left: 12px;
		padding-right: 12px;
	}

	.menu_item_heavy {
		text-align: right;
		font: normal normal bold 18px/24px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_bottom_fixed_br {
		position: absolute;
		background: #28a745 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 24px 0px;
		bottom: 0;
		right: 0;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		display: flex;
	}

	.menu_top_fixed_tr_checked {
		position: absolute;
		background: #28a745 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 0px 24px;
		top: 0;
		right: 0;
		display: ${(props) => (props.showChecked ? 'flex' : 'none')};

		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
	}

	.menu_top_fixed_tr {
		position: absolute;
		background: #fec12d 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 0px 24px;
		top: 0;
		right: 0;
		display: ${(props) => (props.showWarning ? 'flex' : 'none')};

		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
	}

	.menu_paid_total {
		.row_container {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			font: normal normal 500 13px/18px Roboto;
			letter-spacing: 0px;
			color: #222222;
			p {
				margin: 0;
			}
		}
	}
`;
